require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;



/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/~/core-js/library/fn/object/values.js
 ** module id = 430
 ** module chunks = 0
 **/